module.exports = __webpack_public_path__ + "static/media/icon_cancel.49749045.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_cancel.svg
// module id = 478
// module chunks = 0